// eslint-disable-next-line i18next/no-literal-string
export const CRC_NAME = 'custom:crc';
